import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { PricingTable } from './PricingTable';

const firstVaRows = [
    ['Year 1 - BUILD', '$900/month', '$2,500/month', '$15.63/hr'],
    ['Year 2 - OPTIMIZE', '$699/month', '$2,299/month', '$14.37/hr'],
    ['Year 3+ - PROTECT', '$299/month', '$1,899/month', '$11.87/hr'],
];

const additionalVaRows = [
    ['First 12 Months - BUILD', '$699/month', '$2,299/month', '$14.37/hr'],
    ['Month 13+ - OPTIMIZE / PROTECT', '$299/month', '$1,899/month', '$11.87/hr'],
];

export function CostTable() {
    return (
        <section className="bg-[#F8F9FA] py-16 md:py-20" data-testid="cost-table">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-10">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">Cost Transparency</h2>
                    <p className="text-[#6B7280] mt-3">Our fee decreases the longer we work together.</p>
                </motion.div>

                <PricingTable heading="First VA" rows={firstVaRows} testId="cost-table-first-va" />
                <PricingTable
                    heading="Each Additional VA"
                    intro="Each additional VA follows their own independent timeline, starting from their individual hire date."
                    rows={additionalVaRows}
                    testId="cost-table-additional-va"
                />

                <motion.div {...fadeUp} className="space-y-3" data-testid="cost-table-notes">
                    <p className="text-[#6B7280] text-sm">Assumes $10/hour VA wage at 160 hours per month. VA wages are paid directly to your VA.</p>
                    <p className="text-[#6B7280] text-sm">Splitting a VA between two agents adds $200/month.</p>
                    <div className="bg-navy-900 rounded-sm px-8 py-4">
                        <p className="text-gray-300 text-xs">
                            Note: VA talent rates typically range from $8 to $12/hour or more depending on skill set and specialty. Specialized or senior roles may cost more. VA wages are paid directly by you. White Glove Hiring does not mark up labor.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
